import React from 'react'
import * as ReactDOM from 'react-dom'

import App from "./lib/app"



ReactDOM.render(
  <App />,
  document.getElementById('root')
);


